import {Pipe, PipeTransform} from '@angular/core';
import {ConnectionStatusEnum} from '../../services/enums/connection-status.enum';

@Pipe({name: 'connectionsStatusPipe'})
export class ConnectionsStatusPipe implements PipeTransform {
  transform(value: string): string {
    let connectionsStatusIcon;

    if (value === ConnectionStatusEnum.OK) {
      connectionsStatusIcon = '<i class="fa fa-check-circle" title="Available"></i>';
    } else if (value === ConnectionStatusEnum.NOT_OK) {
      connectionsStatusIcon = '<i class="fa fa-times-circle" title="Unavailable"></i>';
    } else if (value === ConnectionStatusEnum.LOCKED) {
      connectionsStatusIcon = '<i class="fa fa-lock" title="Locked"></i>';
    } else {
      connectionsStatusIcon = '<i class="fa fa-check-circle" title="Available"></i>';
    }

    return `<div class="center-content">${connectionsStatusIcon}</div>`;
  }
}
